import { render, staticRenderFns } from "./roomBetList.vue?vue&type=template&id=d37a8ebe&lang=pug&"
import script from "./roomBetList.vue?vue&type=script&lang=js&"
export * from "./roomBetList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports